import Serializer from "../../serializer";
import { ImportTopicData } from "./models";

export function serializeImportTopicsData(data: ImportTopicData) {
  return Serializer.serialize("topics", data);
}
